import { mainApiAxios } from '@/plugins/axios'

export default {
    listRegions() {
        return mainApiAxios.get('location/regions')
    },

    listCities(regionId) {
        return mainApiAxios.get(`location/cities?regionId=${regionId}`)
    },

    listStreetNames(cityId) {
        return mainApiAxios.get(`location/streetnames?cityId=${cityId}`)
    },

    // Admin CRUD
    listRegionsForAdmin(municipalityId) {
        return municipalityId ? mainApiAxios.get(`location/admin/regions?municipalityId=${municipalityId}`) : mainApiAxios.get('location/admin/regions')
    },

    createregion(data) {
        return mainApiAxios.post('location/admin/regions', data)
    },

    updateRegion(id, data) {
        return mainApiAxios.post(`location/admin/regions/${id}`, data)
    },

    deleteRegion(id) {
        return mainApiAxios.post(`location/admin/regions/${id}/delete`)
    },

    listCitiesForAdmin(regionId) {
        const url = regionId ? `location/admin/cities?regionId=${regionId}` : 'location/admin/cities'
        return mainApiAxios.get(url)
    },

    createCity(data) {
        return mainApiAxios.post('location/admin/cities', data)
    },

    updateCity(id, data) {
        return mainApiAxios.post(`location/admin/cities/${id}`, data)
    },

    deleteCity(id) {
        return mainApiAxios.post(`location/admin/cities/${id}/delete`)
    },

    listStreetNamesForAdmin(cityId) {
        const url = cityId ? `location/admin/streetnames?cityId=${cityId}` : 'location/admin/streetnames'
        return mainApiAxios.get(url)
    },

    createStreetName(data) {
        return mainApiAxios.post('location/admin/streetnames', data)
    },

    updateStreetName(id, data) {
        return mainApiAxios.post(`location/admin/streetnames/${id}`, data)
    },

    deleteStreetName(id) {
        return mainApiAxios.post(`location/admin/streetnames/${id}/delete`)
    }
}


